import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import styled from 'styled-components';
import { MultiLineInput } from 'components/atoms/input';
import { SettingsControlPanel } from 'components/molecules/settings/control-panel';
import { useTranslation } from 'hooks/use-translation';
import { useUpdateSettings } from '../use-feature-setting';
import { SettingsLineWrapper } from './components';
const StyledMultiLineInput = styled(MultiLineInput)`
  && {
    height: 128px;
    background-color: var(--gray-10);
    border-color: var(--gray-50);
    border-radius: 0;
    padding: var(--spacing-04) var(--spacing-05);
    &:focus,
    &:hover {
      border-color: var(--gray-50);
    }
  }
`;
export const DefaultNotesSettings = ({ defaultNotes })=>{
    const [notes, setNotes] = useState(defaultNotes);
    const [update, isLoading] = useUpdateSettings();
    const label = useTranslation('settings.credit_notes.default_notes');
    const description = useTranslation('settings.credit_notes.default_notes.description');
    const onBlurHandler = ()=>{
        if (defaultNotes !== (notes === null || notes === void 0 ? void 0 : notes.trim())) {
            update({
                payload: {
                    defaultNotes: notes
                },
                onError: ()=>{
                    setNotes(defaultNotes);
                }
            });
        }
    };
    return /*#__PURE__*/ _jsx(SettingsControlPanel, {
        label: label,
        descriptions: [
            description
        ],
        children: /*#__PURE__*/ _jsx(SettingsLineWrapper, {
            children: /*#__PURE__*/ _jsx(StyledMultiLineInput, {
                value: notes,
                onChange: (e)=>setNotes(e.target.value),
                onBlur: onBlurHandler,
                disabled: isLoading,
                placeholder: useTranslation('placeholder.input')
            })
        })
    });
};
